// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissos_ListaCompromissosDoOrcamentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissos/lista_compromissos_do_orcamento
 *
 * Returns a list of compromissos (appointments) for a specific orcamento
 * (quote). Same SELECT shape as /compromissos/lista_compromissos —
 * Compromissos_model::dadosXcrudCompromissos() is shared — but additionally
 * filtered by compromisso_orcamento_id.
 *
 * Row shape: see Compromissos_ListaCompromissosDoOrcamentoRow. Mirrors the
 * SELECT plus the inserePropriedadeMany() enrichments (franquia, location,
 * operador, vendedor, status_financeiro) and the `permissao` flag added by
 * Compromissos::decorateCompromissosList().
 *
 * @see Compromissos_ListaCompromissosDoOrcamentoRow
 * @see Compromissos_model::dadosXcrudCompromissos() for the source query
 * @see Compromissos::decorateCompromissosList() for injected properties
 */
import type { Compromissos_ListaCompromissosDoOrcamentoRow } from './Compromissos_ListaCompromissosDoOrcamentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Compromissos_ListaCompromissosDoOrcamentoResponseDados = Compromissos_ListaCompromissosDoOrcamentoRow[];

export type Compromissos_ListaCompromissosDoOrcamentoResponse = ApiResponse<Compromissos_ListaCompromissosDoOrcamentoResponseDados>;

registerResponseContract('Compromissos_ListaCompromissosDoOrcamentoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      compromisso_id:                { type: 'number',  required: true },
      compromisso_operador_user_id:  { type: 'string',  required: false },
      compromisso_franquia_id:       { type: 'number',  required: false },
      compromisso_forma_pagamento:   { type: 'number',  required: false },
      cliente_location_type:         { type: 'string',  required: false },
      cliente_location_id:           { type: 'number',  required: false },
      nome_cliente:                  { type: 'string',  required: true },
      cliente_id:                    { type: 'number',  required: true },
      cliente_ddi:                   { type: 'string',  required: false },
      cliente_ddd:                   { type: 'string',  required: false },
      cliente_telefone:              { type: 'string',  required: false },
      bairro:                        { type: 'string',  required: false },
      total:                         { type: 'string',  required: false },
      compromisso_status_financeiro: { type: 'number',  required: false },
      valor_recebido:                { type: 'string',  required: false },
      valor_liquido:                 { type: 'string',  required: false },
      orcamento_user_id:             { type: 'string',  required: false },
      compromisso_data_hora_inicio:  { type: 'string',  required: false },
      compromisso_data_hora_fim:     { type: 'string',  required: false },
      inicio:                        { type: 'string',  required: false },
      fim:                           { type: 'string',  required: false },
      status:                        { type: 'string',  required: false },
      status_raw:                    { type: 'string',  required: true },
      forma_de_pagamento:            { type: 'string',  required: false },
      franquia:                      { type: 'string',  required: false },
      location:                      { type: 'string',  required: false },
      operador:                      { type: 'string',  required: false },
      vendedor:                      { type: 'string',  required: false },
      status_financeiro:             { type: 'string',  required: false },
      permissao:                     { type: 'boolean', required: false },
    },
  },
})
